<template>
  <el-form
      ref="ruleFormRef"
      style="width: 100%;"
      :model="alarmForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm"
      status-icon
  >
    <el-form-item :label="$t('alarm.alarmName')" prop="alarmName">
      <el-input v-model="alarmForm.alarmName" />
    </el-form-item>
    <el-form-item :label="$t('home.deviceName')" prop="executionId">
      <el-select v-model="alarmForm.executionId" filterable :placeholder="$t('alarm.selectActiveDevice')" @change="getDeviceArgList(alarmForm.executionId)">
        <el-option v-for="(item,index) in deviceListData" :key="index" :label="item.deviceName" :value="item.deviceName"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('alarm.triggerType')" prop="triggerType">
      <el-radio-group v-model="alarmForm.triggerType">
        <el-radio
            v-for="dict in triggerTypeList"
            :key="dict.value"
            :label="dict.value"
        >
          {{ $t(dict.label) }}
        </el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item :label="$t('alarm.conditionList')" prop="conditions">
      <div style="width: 100%;" v-for="(item,index) in alarmForm.conditions" :key="index">
        <el-select v-if="index === 0" disabled v-model="item.andor" :placeholder="$t('alarm.and&or')" style="width: 100px; " class="mr-5">
          <el-option v-for="(it,idx) in andor" :key="idx" :label="$t(it.label)" :value="it.value"></el-option>
        </el-select>
        <el-select v-else v-model="item.andor" :placeholder="$t('alarm.and&or')" style="width: 100px; " class="mr-5">
          <el-option v-for="(it,idx) in andor" :key="idx" :label="$t(it.label)" :value="it.value"></el-option>
        </el-select>

        <el-select v-model="item.tslAttribute" :placeholder="$t('alarm.attribute')" class="mr-5px" style="width: 30%;">
          <el-option
              v-for="item in tslAttribute"
              :key="item.value"
              :label="item.functionName"
              :value="item.identifier">
            <span style="float: left">{{ item.functionName }}</span>
            <span
                style="
                float: right;
                color: var(--el-text-color-secondary);
                font-size: 13px;
              "
            >
              {{ item.identifier }}
            </span>
          </el-option>
        </el-select>

        <el-select v-model="item.subconditions" :placeholder="$t('alarm.selectCondition')" style="width: 100px;" class="m-2">
          <el-option v-for="(item,index) in subconditions" :key="index" :label="$t(item.label)" :value="item.value"></el-option>
        </el-select>
        <el-input v-model="item.value" :placeholder="$t('alarm.enterContent')" style="width: 100px;" class="mr-5" />
        <el-button :icon="Delete" class="mr-5" v-if="index != 0" @click="deleteCondition(index)">{{$t('alarm.delete')}}</el-button>
      </div>
      <div>
        <el-button type="primary" @click="addCondition">{{$t('alarm.addCondition')}}</el-button>
      </div>
    </el-form-item>

    <el-form-item :label="$t('alarm.alarmLevel')" prop="alarmLevel">
      <el-radio-group v-model="alarmForm.alarmLevel">
        <el-radio
            v-for="dict in alarmLevelList"
            :key="dict.value"
            :value="dict.value"
            :label="$t(dict.label)"
        >
          {{$t(dict.label)}}
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('alarm.passageway')" prop="passageway">
      <el-select
          v-if="nList"
          v-model="alarmForm.passageway"
          multiple
          :placeholder="$t('alarm.selectPassageway')"
          style="width: 240px"
      >
        <el-option
            v-for="item in nList"
            :key="item.id"
            :label="item.noticeName"
            :value="item.id"
        />
      </el-select>
    </el-form-item>

    <el-collapse v-model="activeNames" @change="handleChange" class="m-4">
      <el-collapse-item :title="$t('alarm.advancedOptions')" name="1">
        <!--高级选项-->
        <el-form-item :label="$t('alarm.manuallyAlarm')" prop="manualRelease">
          <el-select v-model="alarmForm.manualRelease" :placeholder="$t('alarm.selectManually')">
            <el-option
                v-for="dict in manualReleaseList"
                :key="dict.value"
                :label="$t(dict.label)"
                :value="dict.value"
            >
              {{ $t(dict.label) }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('alarm.duration')" prop="durations">
          <el-select v-model="alarmForm.durations" :placeholder="$t('alarm.duration')">
            <el-option v-for="(item,index) in duration" :key="index" :label="item.label + $t('alarm.minute')" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('alarm.hitCount')" prop="hitCounts">
          <el-select v-model="alarmForm.hitCounts" :placeholder="$t('alarm.hitCount')">
            <el-option v-for="(item,index) in hitCountsList" :key="index" :label="item.label + $t('alarm.time')" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('alarm.notificationPeriod')" v-if="alarmForm.complexTime">
          <el-time-select
              v-model="alarmForm.startTime"
              style="width: 240px"
              :max-time="alarmForm.endTime"
              class="mr-4"
              :placeholder="$t('alarm.startTime')"
              start="00:00"
              step="00:15"
              end="24:00"
          />
          <el-time-select
              v-model="alarmForm.endTime"
              style="width: 240px;"
              class="m-2"
              :min-time="alarmForm.startTime"
              :placeholder="$t('alarm.endTime')"
              start="00:00"
              step="00:15"
              end="24:00"
          />
          <el-button type="success" @click="updateTimeType">{{$t('alarm.experienceTime')}}</el-button>
        </el-form-item>
        <el-form-item :label="$t('alarm.effectivePeriod')" prop="name" v-if="!alarmForm.complexTime">
          <div class="time-selector">
            <div class="time-blocks-row">
              <div v-for="(block, index) in 24" :key="index" class="time-block">
                <div>{{formatHour(index)}}</div>
                <div
                    v-for="halfHour in 2"
                    :key="(index * 2) + halfHour - 2"
                    class="half-hour"
                    :class="{ selected: selectedBlocks.includes((index * 2) + halfHour - 1) }"
                    @click="toggleBlock((index * 2) + halfHour - 1)"
                >
                  <!--                          {{ formatTime((index * 2) + halfHour - 1) }}-->
                </div>
              </div>
            </div>
            <div class="selected-time">
              <p v-if="selectedTimeSegments.length === 0">{{$t('alarm.noTimeSelect')}}</p>
              <ul v-else>
                <li v-for="(segment, index) in selectedTimeSegments" :key="index">
                  {{ segment.start }} - {{ segment.end }}
                </li>
              </ul>
            </div>
          </div>
          <el-button type="success" @click="updateTimeType">{{$t('alarm.returnTime')}}</el-button>

        </el-form-item>
      </el-collapse-item>

    </el-collapse>

    <el-form-item>
      <el-button type="primary" @click="submitForm(ruleFormRef)">
        {{$t('group.submit')}}
      </el-button>
      <el-button @click="resetForm(ruleFormRef)">{{$t('group.cancel')}}</el-button>
    </el-form-item>

  </el-form>

</template>
<script setup>

import i18n from "@/language";

const props = defineProps({
  id: {
    type: String
  }
})

import {Delete} from '@element-plus/icons-vue'
import {computed, onMounted, ref, watch} from "vue";
import {deviceList, deviceTsl} from "@/api/device";
import {addAlarm, getAlarmDetail, updateAlarm} from "@/api/alarmRules";
import {ElMessage} from "element-plus";

import { useI18n } from "vue-i18n";
import {notificationList} from "@/api/notificationChannel";

// 引入i18n用于国际化
const { t } = useI18n();

const activeNames = ref([])
const ruleFormRef = ref()
const manualReleaseList = ref([{
  value: 1,
  label: 'alarm.support'
},{
  value: 0,
  label: 'alarm.nonsupport'
}])

const deviceListData = ref(null)
const getDeviceList = ()=>{
  deviceList({pageSize: 100}).then(res=>{
    if(res && res.data && res.data.list){
      deviceListData.value = res.data.list
      console.log(' = 设备列表', res.data)
    }

  })
}

// 如果存在id，则是编辑
const getEditInfo = ()=>{
  console.log(' = props id', props.id)
  if(props.id){

    getAlarmDetail({id:props.id}).then(res=>{
      alarmForm.value = res.data
      console.log(' = deviceName', res.data)
      // return
      getDeviceArgList(res.data.executionId)
    })

  }
}

// 新增并初始化表单的方法
const initAlarmForm = () => {
  alarmForm.value = {
    id: undefined,
    alarmName: undefined,
    dataSource: 1,
    executionId: undefined,
    triggerType: undefined,
    conditions: [
      {
        index: 0,
        andor: 'and',
        tslAttribute:'',
        subconditions:'',
        value:''
      }
    ],
    complexTime: true,
    hitCounts: undefined,
    durations: undefined,
    alarmLevel: undefined,
    passageway: undefined,
    startTime: undefined,
    endTime: undefined,
    manualRelease: 1,
    alarmDesc: undefined,
    timePeriods: [],
    deployState: undefined
  };
};

// defineExpose 编译器宏来显式指定在 <script setup> 组件中要暴露出去的属性：
defineExpose({getEditInfo,initAlarmForm})

const updateTimeType = ()=> {
  alarmForm.value.complexTime = !alarmForm.value.complexTime;
}

const handleChange = (val)=>{
  console.log(val);
}

// 获取设备属性列表
const tslAttribute = ref([]);
const getDeviceArgList = (deviceName)=>{
  console.log(' =  alarmForm.executionId', deviceName)
  deviceTsl({deviceName: deviceName}).then(res=>{
    if(res && res.data && res.data.propertie){
      tslAttribute.value = res.data.propertie.map(item => ({
        functionName: item.functionName,
        identifier: item.identifier
      }))
      console.log(' = ', tslAttribute.value)
    }
  })
}

// 添加条件
const addCondition = ()=>{
  alarmForm.value.conditions.push({
    andor: 'and',
    tslAttribute:'',
    subconditions:'',
    value:''
  })
}

const triggerTypeList = ref([{
  label: 'alarm.attributeChange',
  value: 0
},{
  label: 'alarm.deviceOffLine',
  value: 1
}])
// 告警级别
const alarmLevelList = [{
  label: 'alarm.general',
  value: 0
},{
  label: 'alarm.significance',
  value: 1
},{
  label: 'alarm.seriousness',
  value: 2
}]
// 持续时长
const duration = [{
  label: '01',
  value: 60000
},{
  label: '05',
  value: 300000
},{
  label: '10',
  value: 600000
},{
  label: '15',
  value: 900000
},{
  label: '20',
  value: 1200000
},{
  label: '25',
  value: 1500000
},{
  label: '30',
  value: 1800000
},]


const hitCountsList = [{
  label: '1',
  value: 1
},{
  label: '2',
  value: 2
},{
  label: '3',
  value: 3
},{
  label: '4',
  value: 4
},{
  label: '5',
  value: 5
},{
  label: '6',
  value: 6
},{
  label: '7',
  value: 7
},{
  label: '8',
  value: 9
},{
  label: '9',
  value: 9
},{
  label: '10',
  value: 10
}]

// 删除条件
const deleteCondition = (index)=>{
  alarmForm.value.conditions.splice(index,1)
}


const nList = ref(null)
// 获取通知通道列表
const getNotificationList = (params) => {
  notificationList(params).then(res => {
    if (res && res.data && res.data.list) {
      nList.value = res.data.list
    }
  })
}

onMounted(() => {
  getDeviceList()
  getNotificationList()
})

const alarmForm = ref({
  id: undefined,
  alarmName: undefined,
  dataSource: 1,
  executionId: undefined,
  triggerType: undefined,
  conditions: [
    {
      index: 0,
      andor: 'and',
      tslAttribute:'',
      subconditions:'',
      value:''
    }
  ],
  complexTime: true,
  hitCounts: undefined,
  durations: undefined,
  alarmLevel: undefined,
  passageway: undefined,
  startTime: undefined,
  endTime: undefined,
  manualRelease: 1,
  alarmDesc: undefined,
  timePeriods: [],
  deployState: undefined
})
const rules = computed(()=>({
  alarmName: [{ required: true, message: t('alarm.alarmNameNot'), trigger: 'blur' }],
  dataSource: [{ required: true, message: t('alarm.sourceTypeNot'), trigger: 'blur' }],
  executionId: [{ required: true, message: t('alarm.sourceNot'), trigger: 'blur' }],
  triggerType: [{ required: true, message: t('alarm.triggerTypeNot'), trigger: 'blur' }],
  conditions: [{ required: true, message: t('alarm.conditionsNot'), trigger: 'blur' }],
  alarmLevel: [{ required: true, message: t('alarm.severityNot'), trigger: 'blur' }],
  manualRelease: [{ required: true, message: t('alarm.manuallyNot'), trigger: 'blur' }]

}))


// const updateRules = () => {
//   rules.value = {
//     alarmName: [{ required: true, message: t('alarm.alarmNameNot'), trigger: 'blur' }],
//     // 其他字段同样
//   };
// };
//
// watch(() => i18n.locale, updateRules);


const submitForm = async (formEl) => {
  console.log(' = alarmForm', alarmForm.value)
  // return
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log('submit!', alarmForm.value)
      if(props.id){
        updateAlarm(alarmForm.value).then(()=>{
          ElMessage({
            message: t('alarm.success'),
            type: 'success',
          })
          emit('submitCancel')
        }).catch(err=>{
          console.log(' = err 规则', err)
          ElMessage.error(t('alarm.fail'))
        })
      } else {
        addAlarm(alarmForm.value).then(()=>{
          ElMessage({
            message: t('alarm.success'),
            type: 'success',
          })
          emit('submitCancel')
        }).catch(err=>{
          console.log(' = err 规则', err)
          ElMessage.error(t('alarm.fail'))
        })
      }

    } else {
      console.log('error submit!', fields)
    }
  })
}


const emit = defineEmits(['submitCancel'])
const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
  emit('submitCancel')
}


/**
 * 多时间段选择 start
 * */

const selectedBlocks = ref([]);

const toggleBlock = (index) => {
  const selectedIndex = selectedBlocks.value.indexOf(index);
  if (selectedIndex === -1) {
    selectedBlocks.value.push(index);
    selectedBlocks.value = selectedBlocks.value.slice().sort((a, b) => a - b);
  } else {
    selectedBlocks.value.splice(selectedIndex, 1);
  }
  console.log('selectedBlocks', selectedBlocks)
  alarmForm.value.timePeriods = selectedBlocks
};


const formatHour = (index) => {
  if (index < 10) {
    return '0' + String(index)
  } else {
    return index
  }
}

const formatTime = (index, isend) => {
  // 参数验证：确保index是非负整数
  if (!Number.isInteger(index) || index < 0) {
    throw new Error('Invalid input: index must be a non-negative integer.');
  }

  // 处理边界条件：index为0时显式返回"00:00"
  if (index === 0) {
    if (isend){
      return '00:30'
    }
    return '00:00';
  }

  // 调整逻辑以支持24小时制
  let hours = Math.floor(index / 2) % 24;

  // 简化分钟的计算逻辑
  let minutes = index % 2 === 0 ? '00' : '30';

  if (isend) {
    // 如果 isend 为 true，将时间加半小时
    if (minutes === '00') {
      minutes = '30';
    } else {
      minutes = '00';
      hours = (hours + 1) % 24; // 小时加1，并取余 24
    }
  }

  // 返回格式化的时间字符串
  return `${hours < 10 ? '0' : ''}${hours}:${minutes}`;
};

const selectedTimeSegments = computed(() => {
  const segments = [];
  let startBlock = null;
  let endBlock = null;

  selectedBlocks.value.forEach((block, index) => {
    if (index === 0 || block !== selectedBlocks.value[index - 1] + 1) {
      // Start of a new segment
      startBlock = block;
      endBlock = block; // Reset end block to start block
    } else {
      endBlock = block;
    }

    // If it's the last block or the next block is not continuous
    if (index === selectedBlocks.value.length - 1 || block !== selectedBlocks.value[index + 1] - 1) {
      if (startBlock !== null && endBlock !== null) {
        segments.push({
          start: formatTime(startBlock,false),
          end: formatTime(endBlock,true),
        });
      }
    }
  });

  return segments;
});

/**
 * 多时间段选择 end
 * */


const andor = [
  {
    label:"alarm.and",
    value:"and"
  },{
    label:"alarm.or",
    value:"or"
  }
]

const subconditions = [
  {
    label:"alarm.greaterThan",
    value:">"
  },{
    label:"alarm.equalOrGreater",
    value:">="
  },{
    label:"alarm.lessThan",
    value:"<"
  },{
    label:"alarm.lessEqual",
    value:"<="
  },{
    label:"alarm.equalTo",
    value:"="
  },{
    label:"alarm.unequalTo",
    value:"!="
  }
]

</script>
<style>
.el-collapse {
  border: none;
}
.time-selector {
  width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.time-blocks-row {
    width: 100%;
    display: flex;
    justify-content: space-around;
}

.time-block {
    display: flex;
    flex-direction: column;

}

.half-hour {
    width: 16px;
    height: 12px;
    cursor: pointer;
    border-radius: 2px;
    padding: 5px;
    margin: 2px;
    background-color: #eeeeee;
}

.selected {
    background-color: #409eff;
}

.selected-time {
    margin-top: 20px;
}

.mr-5 {
  margin-right: 5px;
}

</style>
